<template>
  <SogForm
    ref="_form"
  >
    <SogFormField>
      <SogNumericTextBox
        v-model="_formulareZumVersand"
        placeholder="Formulare zum Versand"
        name="formulareZumVersand"
        format="N"
        :min="0"
      />
    </SogFormField>
    <SogFormField>
      <SogNumericTextBox
        v-model="_min"
        placeholder="Mindest Bestand"
        name="min"
        format="N"
        :min="0"
      />
    </SogFormField>
  </SogForm>
</template>

<script setup lang="ts">

import SogForm from "@/shared/ui/SogForm.vue";
import PersonDetails from "@/shared/model/personDetails";
import {ref, watch} from "vue";
import PersonDetailsId from "@/shared/model/personDetailsId";
import Person from "@/shared/model/person";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";

const _form = ref<InstanceType<typeof SogForm> | null>(null)

interface Props {
  person?: Person,
  details?: PersonDetails
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
  person: undefined,
  details: undefined
})

const _formulareZumVersand = ref<number>(0)
const _min = ref<number>(0)


function validate(): boolean {
  return _form.value?.validate() ?? false;
}

watch(props, () => {
  _formulareZumVersand.value = props.details?.getNumberValue(PersonDetailsId.ExportBlankCountToSend) ?? 0
  _min.value = props.details?.getNumberValue(PersonDetailsId.ExportBlankMinimumCount) ?? 0
}, {immediate: true})

function getDetails(): PersonDetails | undefined {
  if (!validate()) return undefined;
  const details = new PersonDetails(props?.details?.getValues());
  details.setNumberValue(PersonDetailsId.ExportBlankCountToSend, _formulareZumVersand.value)
  details.setNumberValue(PersonDetailsId.ExportBlankMinimumCount, _min.value)
  return details;
}

defineExpose({
  validate,
  getDetails
})
</script>

<style scoped>

</style>
